import PubNubReact from "pubnub-react"
import { Component } from "react"

class PubnubController extends Component {
  constructor(props) {
    super(props)
    this.pubnub = new PubNubReact({
      publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY,
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY,
      uuid: this.props.uuid,
      heartbeatInterval: 10,
      presenceTimeout: 15,
      ssl: true,
      state: this.props.state
    })
    this.pubnub.init(this)
  }

  componentWillMount() {
    this.pubnub.subscribe({
      channels: [this.props.channelName],
      withPresence: true
    })

    this.pubnub.getMessage(this.props.channelName, msg => {
      this.props.onMessage(msg.message)
    })

    this.pubnub.getStatus(st => {
      if (this.props.hasOwnProperty("onStatus")) {
        this.props.onStatus(st)
      }
    })
  }

  componentWillUnmount() {
    this.pubnub.unsubscribe({
      channels: [this.props.channelName]
    })
  }

  publish(message) {
    const { channelName: channel } = this.props
    this.pubnub.publish({
      message,
      channel
    })
  }

  render() {
    return null
  }
}
export default PubnubController



// WEBPACK FOOTER //
// ./src/components/PubnubController/index.jsx